import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Header } from "@/components/Header";
import { KnowledgeConnections } from "@/components/knowledge/KnowledgeConnections";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { JsonLd } from "@/components/JsonLd";
import { generateCanonicalUrl } from "@/utils/seoHelpers";

const GoogleAdsTomballPage = () => {
  const [language] = useState<'es' | 'en'>('es');
  const canonical = generateCanonicalUrl('/google-ads-tomball');

  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Google Ads en Tomball TX",
    areaServed: {
      "@type": "Place",
      name: "Tomball, Texas"
    },
    provider: { "@id": "https://luisroc.com/#organization" },
    description: "Campañas de Google Ads en Tomball, TX para captar clientes locales. Estrategia, optimización y medición de conversiones."
  };

  return (
    <>
      <Helmet>
        <html lang={language} />
        <title>Google Ads Tomball TX | PPC Local – Luis ROC</title>
        <meta name="description" content="Campañas de Google Ads en Tomball, TX para captar clientes locales. Estrategia, optimización y medición de conversiones." />
        <meta name="keywords" content="Google Ads Tomball, publicidad Google Tomball, PPC Tomball TX, SEM Tomball, agencia Google Ads" />
        <link rel="canonical" href={canonical} />
      </Helmet>

      <JsonLd data={serviceSchema} />

      <div className="min-h-screen bg-background">
        <Header language={language} onLanguageChange={() => {}} />
        <main className="container mx-auto px-4 py-16 text-center">
          <h1 className="text-4xl font-bold mb-6">Google Ads en Tomball TX</h1>
          <p className="max-w-2xl mx-auto mb-8 text-muted-foreground">
            Atrae clientes de Tomball con campañas segmentadas, anuncios de alto CTR y optimización constante enfocada en resultados.
          </p>
          <Button size="lg" onClick={() => (window.location.href = "/contacto")}>Reunión inicial gratuita de 30 minutos</Button>
        </main>
        <KnowledgeConnections path="/google-ads-tomball" language={language} />

        <Footer language={language} />
      </div>
    </>
  );
};
export default GoogleAdsTomballPage;
